<template>
  <div class="form-wizard-page">
    <div class="va-row">
      <div class="flex md12">
        <vuestic-widget
          class="no-h-padding"
          :headerText="$t('companies.register')">

          <vuestic-wizard :steps="companyRegistration">

            <div slot="pageCompanyName" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyName'), 'valid': isFormFieldValid('companyName')}">
                <div class="input-group">
                  <input
                    name="companyName"
                    data-vv-as="Name"
                    v-model="companyName"
                    v-validate="'required'"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.name' |
                    translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('companyName')" class="help text-danger">
                    {{ errors.first('companyName') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageCompanyCountry" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p>Zebras communicate with facial expressions and sounds. They
                  make loud braying or barking sounds and
                  soft snorting sounds. The position of their ears, how wide
                  open their eyes are, and whether they show
                  their teeth all send a signal. For example, ears flat back
                  means trouble, or "you better follow orders!"</p>
              </div>
              <vuestic-simple-select
                label="Select country"
                v-model="hrCountry"
                name="country"
                :required="true"
                ref="hrCountrySelect"
                v-bind:options="countriesList">
              </vuestic-simple-select>
            </div>

            <div slot="pageCompanyVAT" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyVatNumber'), 'valid': isFormFieldValid('companyVatNumber')}">
                <div class="input-group">
                  <input
                    name="companyVatNumber"
                    data-vv-as="VAT"
                    v-model="companyVatNumber"
                    v-validate="'required'"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.vat' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('companyVatNumber')" class="help text-danger">
                    {{ errors.first('companyVatNumber') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageCompanyNumber" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyNumber'), 'valid': isFormFieldValid('companyNumber')}">
                <div class="input-group">
                  <input
                    name="companyNumber"
                    data-vv-as="Company Number"
                    v-model="companyNumber"
                    v-validate="'required'"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.companyNumber' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('companyNumber')" class="help text-danger">
                    {{ errors.first('companyNumber') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageCompanyPassword" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyPassword'), 'valid': isFormFieldValid('companyPassword')}">
                <div class="input-group">
                  <input
                    name="password"
                    data-vv-as="Password"
                    v-model="password"
                    v-validate="'required'"
                    type="password"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.companyPassword' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('companyVatNumber')" class="help text-danger">
                    {{ errors.first('companyPassword') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageCompanyEmail" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyEmail'), 'valid': isFormFieldValid('companyEmail')}">
                <div class="input-group">
                  <input
                    name="companyEmail"
                    data-vv-as="Company Email"
                    v-model="companyEmail"
                    v-validate="'required'"
                    type="email"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.companyEmail' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('companyNumber')" class="help text-danger">
                    {{ errors.first('companyEmail') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageAddress" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('address'), 'valid': isFormFieldValid('address')}">
                <div class="input-group">
                  <input
                    name="address"
                    data-vv-as="Address"
                    v-model="address"
                    v-validate="'required'"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.address' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('address')" class="help text-danger">
                    {{ errors.first('address') }}
                  </small>
                </div>
              </div>
            </div>

            <div slot="pageCompanyPhone" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="form-group with-icon-right"
                   :class="{'has-error': errors.has('companyPhone'), 'valid': isFormFieldValid('companyPhone')}">
                <div class="input-group">
                  <input
                    name="companyPhone"
                    data-vv-as="Company Phone"
                    v-model="companyPhone"
                    v-validate="'required'"
                    required title=""/>
                  <i
                    class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'forms.wizard.companyPhone' | translate}}</label><i class="bar"></i>
                  <small v-show="errors.has('address')" class="help text-danger">
                    {{ errors.first('companyPhone') }}
                  </small>
                </div>
              </div>
            </div>

            <!--            <div slot="page3" class="form-wizard-tab-content">-->
            <!--              <h4>{{'forms.wizard.confirmSelection' | translate}}</h4>-->
            <!--              <p>-->
            <!--                Zebras communicate with facial expressions and sounds. They make-->
            <!--                loud braying or barking sounds and-->
            <!--                soft snorting sounds. The position of their ears, how wide open-->
            <!--                their eyes are, and whether they show-->
            <!--                their teeth all send a signal. For example, ears flat back means-->
            <!--                trouble, or "you better follow orders!"-->
            <!--              </p>-->
            <!--            </div>-->

            <div slot="wizardCompleted" class="form-wizard-tab-content">
              <h4>{{'forms.wizard.completed' | translate}}</h4>
              <p>
                Zebras communicate with facial expressions and sounds. They make
                loud braying or barking sounds and
                soft snorting sounds. The position of their ears, how wide open
                their eyes are, and whether they show
                their teeth all send a signal. For example, ears flat back means
                trouble, or "you better follow orders!"
              </p>
            </div>
          </vuestic-wizard>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import CountriesList from 'data/CountriesList'
import { companiesApi } from '../../../services/api/companiesApi'
import {gather} from '../../../services/utils'

export default {
  name: 'register',

  computed: {
    companyRegistration () {
      return [
        {
          label: this.$t('companies.wizard.stepCompanyName'),
          slot: 'pageCompanyName',
          onNext: () => {
            this.validateFormField('companyName')
          },
          isValid: () => {
            return this.isFormFieldValid('companyName')
          },
        },

        {
          label: this.$t('companies.wizard.stepVAT'),
          slot: 'pageCompanyVAT',
          onNext: () => {
            this.validateFormField('companyVatNumber')
          },
          isValid: () => {
            return this.isFormFieldValid('companyName')
          },
        },

        {
          label: this.$t('forms.wizard.stepTwo'),
          slot: 'pageCompanyCountry',
          onNext: () => {
            this.$refs.hrCountrySelect.validate()
          },
          isValid: () => {
            return this.$refs.hrCountrySelect.isValid()
          },
        },

        {
          label: this.$t('forms.wizard.stepThree'),
          slot: 'pageCompanyNumber',
          onNext: () => {
            this.validateFormField('companyNumber')
          },

          isValid: () => {
            return this.isFormFieldValid('companyNumber')
          }
        },

        {
          label: this.$t('forms.wizard.step.companyPassword'),
          slot: 'pageCompanyPassword',

          onNext: () => {
            this.validateFormField('password')
          },

          isValid: () => {
            return this.isFormFieldValid('password')
          }
        },

        {
          label: this.$t('forms.wizard.step.companyEmail'),
          slot: 'pageCompanyEmail',

          onNext: () => {
            this.validateFormField('companyEmail')
          },

          isValid: () => {
            return this.isFormFieldValid('companyEmail')
          }
        },

        {
          label: this.$t('forms.wizard.step.address'),
          slot: 'pageAddress',

          onNext: () => {
            this.validateFormField('address')
          },

          isValid: () => {
            return this.isFormFieldValid('address')
          }
        },

        {
          label: this.$t('forms.wizard.companyPhone'),
          slot: 'pageCompanyPhone',

          onNext: () => {
            this.validateFormField('companyPhone')

            companies.create(gather.call(this, [
              'companyName',
              'companyVatNumber',
              'companyNumber',
              'password',
              'hrCountry',
              'address',
              'companyPhone',
              'companyEmail'
            ]))
          },

          isValid: () => {
            return this.isFormFieldValid('companyPhone')
          }
        }
      ]
    },
  },
  data () {
    return {
      hsName: '',
      hsCountry: '',
      companyName: '',
      companyVatNumber: '',
      companyNumber: '',
      password: '',
      hrCountry: '',
      address: '',
      companyPhone: '',
      vsName: '',
      vsCountry: '',
      companyEmail: '',
      countriesList: CountriesList,
      chosenCountry: '',
    }
  },
  methods: {
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid = this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    validateFormField (fieldName) {
      this.$validator.validate(fieldName, this[fieldName])
    },
  },
}
</script>

<style lang="scss">

</style>
